module.exports = __webpack_public_path__ + "img/verlosung.707002ce.svg";